import React from 'react'
import DatePicker from "react-datepicker"
import moment from '../../helpers/moment'
import PropTypes from 'prop-types'

const MomentDatePicker = props => {

  props = Object.assign({
    value: null,
    displayFormat: "DD-MMM-YYYY",
    additionalInputFormats: [],
    timeZone: 'ETC/UTC',
    isValid: true,
    minDate: null,
    maxDate: null,
    excludeDates: [],
    onChange: ()=>{},
    className: ''
  }, props)

  const formatMoment = (momentInput, format) => {
    if(!momentInput){
      return ''
    }
    else if(momentInput.isValid()){
      return momentInput.format(format)
    }
    else{
      return momentInput.creationData().input
    }
  }

  const updateValueFromString = (stringInput)=>{
    const inputFormats = [props.displayFormat].concat(props.additionalInputFormats)
    const momentInputInTimeZone = moment.tz(stringInput, inputFormats, true, props.timeZone).startOf('day')
    props.onChange(momentInputInTimeZone)
  }

  // need to mess with the dates for the date picker
  // the datepicker only take javascript dates, javascript dates are ALWAYS in UTC
  // because we want the date in the timezone of the pool we have to manually add
  // the timezone offset
  const toJsDate = (moment)=>{
    if(!moment || !moment.isValid())
      return null

    let modfiedMoment = moment.clone().add(moment.utcOffset(), 'minute')
    return modfiedMoment.toDate()
  }

  return  <DatePicker
    id={props.id}
    customInput={<div>
      <div className={"input-group " + props.className}>
        <input
          className={"form-control" + (props.isValid ? "" : " is-invalid")}
          placeholder={props.placeholder}
          type="text"
          value={formatMoment(props.value, props.displayFormat)}
          disabled={props.disabled}
          onChange={e => {
            updateValueFromString(e.target.value)
            e.stopPropagation()
          }}/>
        <div className="input-group-append">
          <div className="input-group-text">
            <span className="fa fa-calendar" />
          </div>
        </div>
      </div>
    </div>}
    selected={toJsDate(props.value)}
    excludeDates={props.excludeDates.map(d=>toJsDate(d))}
    onChange={e => updateValueFromString(moment(e).format(props.displayFormat))}
    minDate={toJsDate(props.minDate)}
    maxDate={toJsDate(props.maxDate)}
  />
}

const PropTypeMoment = (props, propName, componentName) =>
  props[propName] == null || moment.isMoment(props[propName])
    ? null
    : new Error(
        `${componentName}: prop type '${propName}' is invalid; it must be a 'moment', but received '${props[propName]}'`
      );


MomentDatePicker.propTypes = {
  value: PropTypeMoment,
  displayFormat: PropTypes.string,
  additionalInputFormats: PropTypes.array,
  timeZone: PropTypes.string,
  isValid: PropTypes.bool,
  minDate: PropTypeMoment,
  maxDate: PropTypeMoment,
  excludeDates: PropTypes.array,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  id: PropTypes.string,
  disabled: PropTypes.bool
  ,className: PropTypes.string
}

export default MomentDatePicker



// WEBPACK FOOTER //
// ./src/components/momentDatePicker/index.js